module.exports = __webpack_public_path__ + "Frame406-8f92753a.webp";